import { render, staticRenderFns } from "./QrcodeExt.vue?vue&type=template&id=02fa0fc6&scoped=true&"
import script from "./QrcodeExt.vue?vue&type=script&lang=js&"
export * from "./QrcodeExt.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeExt.vue?vue&type=style&index=0&id=02fa0fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fa0fc6",
  null
  
)

export default component.exports